import { connect } from "react-redux";

import { setColGrouping, setHiddenColGrouping } from "../../../Engine/ActionCreators/AllActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import {
    getColumnGroupingGroupStates,
    getHiddenColgroupingGroupStates,
} from "../../../Helpers/StateAccessors/ColgroupHelpers";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { isNodeOrChildrenContainsNotEmptyValue } from "../../viewModelUtils";
import { withResolvePaths } from "../../withResolvePaths";
import { ControlDependency, withRuntimeDependencies } from "../../withRuntimeDependencies";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withTablePath } from "../CrossfitTable/TablePathContext";

import { TableCell, TableCellProps } from "./TableCell";

interface TableCellOwnProps {
    groupKey?: string;
    children: JSX.Element;
    tablePath: string;
    hiddenGroup: string;
    groupText: JSX.Element;
    dependencies: ControlDependency[];
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: TableCellOwnProps) => {
    const { groupKey, tablePath, hiddenGroup = "", dependencies = [], viewModelSelect } = ownProps;

    const filled = dependencies.some(({ path }) =>
        isNodeOrChildrenContainsNotEmptyValue(viewModelSelect.node(state, path))
    );
    const grouped = (getColumnGroupingGroupStates(state, tablePath, groupKey) || 0) === 0;
    const hiddenColgroupState = getHiddenColgroupingGroupStates(state, tablePath, hiddenGroup).state || "auto";
    const hiddenColgroupFilledCount = getHiddenColgroupingGroupStates(state, tablePath, hiddenGroup).filledCount || 0;
    const isHide = hiddenColgroupState === "auto" ? hiddenColgroupFilledCount === 0 : hiddenColgroupState === "hide";
    const bindingPath = dependencies.map(({ path }) => path).join("");

    const props = {
        grouped: grouped,
        isHide: isHide,
        filled: filled,
        bindingPath: bindingPath,
        firstDependencyPath: dependencies[0]?.path,
    };

    return props;
};

function mapDispatchToProps(
    dispatch: CandyDispatch,
    ownProps: TableCellOwnProps
): Pick<TableCellProps, "onShowColumns" | "onHideColumns" | "onShowColGrouping" | "onHideColGrouping"> {
    return {
        onShowColumns: (doNotThrottle?: boolean) => {
            dispatch(setColGrouping(ownProps.tablePath, ownProps.groupKey, true, doNotThrottle));
        },
        onHideColumns: () => {
            dispatch(setColGrouping(ownProps.tablePath, ownProps.groupKey, false));
        },
        onShowColGrouping: (doNotThrottle?: boolean) => {
            dispatch(setHiddenColGrouping(ownProps.tablePath, ownProps.hiddenGroup, true, doNotThrottle));
        },
        onHideColGrouping: () => {
            dispatch(setHiddenColGrouping(ownProps.tablePath, ownProps.hiddenGroup, false));
        },
    };
}

export const TableCellContainer = withRuntimeDependencies(
    withResolvePaths(withViewModelSelect(withTablePath(connect(mapStateToProps, mapDispatchToProps)(TableCell))))
);
